import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Räknas alla styrelseledamöter i PBI-kretsen?";
const SHORT_ANSWER = "Ja. Alla styrelseledamöter prövas, även suppleanter om de träder in i praktiken eller om styrelsen är liten.";

export const Route = createFileRoute("/fraga/vem-galler-som-styrelseledamot-vid-pbi-prov")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Räknas alla styrelseledamöter i PBI-kretsen" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Det räcker inte att ha en 'passiv' ledamot. Alla med rätt att besluta i bolaget prövas. Det är därför som ändringar i styrelse alltid ska anmälas direkt."}
      source={{ label: "Folkhälsomyndigheten – Serveringstillstånd (vägledning)", href: "https://www.folkhalsomyndigheten.se/livsvillkor-levnadsvanor/alkohol-narkotika-dopning-tobak-och-spel-andts/tillsynsvagledning-enligt-alkohollagen/serveringstillstand/" }}
      extraSources={[]}
      deepGuide={{ to: "/pbi-krets", label: "Vilka i styrelsen prövas" }}
      related={[{"to": "/fraga/vilken-aldersgrans-galler-for-servering", "label": "Vilken åldersgräns gäller för servering av alkohol?"}, {"to": "/fraga/far-jag-servera-till-onykter-gast", "label": "Får jag servera alkohol till en onykter gäst?"}, {"to": "/fraga/vad-ar-bulvanforhallanden", "label": "Vad är ett bulvanförhållande?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Räknas alla styrelseledamöter i PBI-kretsen?" },
      { name: "description", content: "Ja. Alla styrelseledamöter prövas, även suppleanter om de träder in i praktiken eller om styrelsen är liten." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/vem-galler-som-styrelseledamot-vid-pbi-prov" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/vem-galler-som-styrelseledamot-vid-pbi-prov" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/vem-galler-som-styrelseledamot-vid-pbi-prov",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Räknas alla styrelseledamöter i PBI-kretsen", url: "https://alkoholprovet.se/fraga/vem-galler-som-styrelseledamot-vid-pbi-prov" },
      ]),
    ],
  }),
});
